import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Row, Col, Card, Typography, Modal, Tooltip } from "antd";
import "../../../../assets/css/index.css";
import CompanyAttributes from "./pages/attributes";
import EbitdaContent from "./pages/ebitda";
import IntrinsicContent from "./pages/intrinsic";
import ExtrinsicContent from "./pages/extrinsic";
import { GoalsListSkeleton } from "../../../../components/page-skeleton";
import { saleThreeSuggestions, saleTwoSuggestions } from "../../../../constant";
import DocumentsModal from "./components/documents-modal";
import NotesModal from "./components/notes-modal";
import { Close, Delete, Edit } from "@mui/icons-material";
import { AddModal, DeleteCompanyModal } from "../company-submission/components/modal";
import { Link } from "react-router-dom";
const { Title } = Typography;

const LeadsDashboard = () => {
  // STATES
  const [documentModalPreview, setdocumentModalPreview] = useState(false);
  const [notesModalPreview, setnotesModalPreview] = useState(false);
  const [attributes, setAttributes] = useState({});
  const [isLoading, setLoading] = useState(false);
  const [financialPreview, setfinancialPreview] = useState(false);
  const [financials, setFinancials] = useState([]);
  const [financialsVal, setfinancialsVal] = useState({});
  const [deleteModalPreview, setDeleteModalPreview] = useState(false);
  const [editModalPreview, setEditModalPreview] = useState(false);
  const [state, setState] = useState({
    tree: [],
  });

  // REDUX DATA
  const user = useSelector((state) => state.UserReducer.profile);
  const company = useSelector((state) => state.CompanyReducer.selected_company);

  // CONST VALS
  const { http } = global.services;

  // HELPERS
  const init = async () => {
    const { user_input } = company;
    if (user_input && user_input.length > 0) {
      let attr = {};
      user_input.map((u, i) => {
        Object.keys(u).map((k) => {
          if (i == 0 && u[k].length > 1) attr[k] = u[k][1];
          else if (u[k].length > 0) {
            attr[k] = u[k];
          } else {
            attr[k] = u[k][0];
          }
        });
      });
      setAttributes(attr);
      setfinancialsVal(user_input[2]);
    } else {
      setAttributes({});
      setState({ ...state, tree: [] });
    }
  };

  const initGoals = async () => {
    let tree = [];
    setLoading(true);
    let { data } = await http.get("question");
    setLoading(false);
    const { goals, financials } = data.data;
    setFinancials(financials);
    goals.forEach((g) => {
      let isValidNumber = typeof attributes[g.key] === "number";
      let isValidString =
        typeof attributes[g.key] === "string" && attributes[g.key] !== "none";
      let isValidObject =
        typeof attributes[g.key] === "object" &&
        attributes[g.key].length > 0 &&
        !attributes[g.key].includes("none");
      if (isValidNumber || isValidString || isValidObject) {
        let goal = g;
        let value =
          typeof attributes[g.key] === "object"
            ? attributes[g.key].join(", ")
            : attributes[g.key];

        if (goal.type === "currency") {
          value = "$" + formatValue(value);
        } else if (goal.type === "percentage") {
          value = value + "%";
        }

        goal.value = value;
        tree.push(goal);
      }
    });

    // if (attributes['question-one'] === 'Raise') {
    //     goals.map(g => {
    //         if (['question-one', 'recap-one', 'recap-two'].includes(g.key)) {
    //             let goal = g
    //             goal.value = attributes[g.key]
    //             tree.push(goal)
    //         }
    //     })
    // } else {
    //     goals.map(g => {
    //         if (['question-one', 'sale-one'].includes(g.key)) {
    //             let goal = g
    //             goal.value = attributes[g.key]
    //             tree.push(goal)
    //         }
    //     })
    // }

    setState({ ...state, tree: tree });
  };

  const formatValue = (val) => {
    let value = Number(val);
    if (value >= 1000000) {
      if (value % 1000000 === 0) {
        val = value / 1000000 + "mm";
      } else {
        val = parseFloat(value / 1000000).toFixed(2) + "mm";
      }
    } else {
      val = value.toLocaleString();
    }

    return val;
  };

  // HANDLERS
  const documensModalHandler = () => {
    setdocumentModalPreview(!documentModalPreview);
  };

  const notesModalHandler = () => {
    setnotesModalPreview(!notesModalPreview);
  };

  const editCompanyPreviewHandler = () => {
    setEditModalPreview(!editModalPreview);
  };

  const deleteCompanyPreviewHandler = () => {
    setDeleteModalPreview(!deleteModalPreview);
  };

  // HOOKS
  useEffect(() => {
    company && init();
  }, [company]);

  useEffect(() => {
    Object.keys(attributes).length && initGoals();
  }, [attributes]);

  return (
    <React.Fragment>
      <div className="top-header">
        <h2 className="page-title">
          {company.company_name || "Company Name"}
          {company?.created_by_user && (
            <span className="action-items">
              <Tooltip title="Edit Company Name">
                <button className="edit-btn" onClick={editCompanyPreviewHandler}>
                  <Edit />
                </button>
              </Tooltip>
              <Tooltip title="Delete Company">
                <button className="delete-btn" onClick={deleteCompanyPreviewHandler}>
                  <Delete />
                </button>
              </Tooltip>
            </span>
          )}
        </h2>
        <div className="action-box">
          <Link to="company-submission">
            <button className="financial-toggle">Edit Company</button>
          </Link>
          <Link to="/company-tasks">
            <button className="financial-toggle">Tasks</button>
          </Link>
          <button className="financial-toggle" onClick={() => setfinancialPreview(true)}>
            Financials
          </button>
          <button className="financial-toggle" onClick={notesModalHandler}>
            Notes
          </button>
          <button className="financial-toggle" onClick={documensModalHandler}>
            Documents
          </button>
        </div>
      </div>
      <div className="spacer"></div>
      <Row gutter={[16, 32]}>
        <Col span={13}>
          <React.Fragment>
            <Card bordered={false} className="home-card">
              {/* <Title level={4}>{company.company_name || "Company Name"}</Title> */}
              <Title level={4}>Description</Title>
              <p className="company-des">{attributes?.description_input}</p>
            </Card>
          </React.Fragment>
        </Col>
        <Col span={11}>
          <div className="flex flex-row" style={{ gap: 16 }}>
            <div className="flex-1">
              <Card bordered={false} className="home-card">
                <EbitdaContent attributes={attributes} />
              </Card>
            </div>
            <div className="flex-1">
              <Card bordered={false} className="home-card">
                <IntrinsicContent attributes={attributes} />
              </Card>
            </div>
            <div className="flex-1">
              <Card bordered={false} className="home-card">
                <ExtrinsicContent attributes={attributes} />
              </Card>
            </div>
            {/* <div className='flex-1'>
                            <Card bordered={false}>
                                <Report attributes={attributes} />
                            </Card>
                        </div> */}
          </div>
        </Col>
      </Row>
      <div className="spacer-lg"></div>
      <Row gutter={[16, 32]}>
        <Col span={13}>
          <Card bordered={false} className="home-card" style={{ minHeight: 680 }}>
            <Title level={3}>Goals</Title>
            {isLoading ? (
              <GoalsListSkeleton />
            ) : (
              <div style={{ marginTop: 8 }}>
                {attributes &&
                  attributes["question-one"] &&
                  !attributes["question-one"].includes("none") && (
                    <>
                      {state.tree.map((t) => (
                        <div
                          key={t.question}
                          style={{
                            marginBottom: 12,
                            borderBottom: "1px solid rgba(38, 38, 38, 0.1)",
                          }}
                        >
                          <span className="goal-title">{t.question}</span> <br />
                          <p className="goal-value">
                            {t.value}
                            {"  "}
                            {t.key === "sale-two"
                              ? `(${saleTwoSuggestions[t.value - 1]})`
                              : t.key === "sale-three"
                              ? `(${saleThreeSuggestions[t.value - 1]})`
                              : ""}
                          </p>
                        </div>
                      ))}
                    </>
                  )}
              </div>
            )}
          </Card>
          <div className="spacer"></div>
        </Col>
        <Col span={11}>
          <CompanyAttributes attributes={attributes} />
        </Col>
      </Row>
      {editModalPreview && (
        <AddModal
          isEdit={true}
          data={company}
          show={editModalPreview}
          onClose={() => setEditModalPreview(false)}
          currentCompany={company}
          isOrganization={user.organization}
        />
      )}
      <DeleteCompanyModal
        navigateToListing
        preview={deleteModalPreview}
        selectedCompany={company}
        previewHandler={() => setDeleteModalPreview(false)}
      />
      <Modal
        className="financials-modal"
        visible={financialPreview}
        width={1000}
        closable={false}
        footer={null}
      >
        <div className="top-box">
          <h2>Financials</h2>
          <button className="close-btn" onClick={() => setfinancialPreview(false)}>
            <Close />
          </button>
        </div>
        <Row gutter={[16, 24]}>
          <Col xs={24} md={8}>
            <Card title="Revenue">
              {financials.map((data, index) => {
                if ((!data.options && !data.type) || !data.key.includes("revenue"))
                  return null;

                return (
                  <React.Fragment key={index}>
                    {data.question.map((qstn, q_i) => (
                      <p key={`question-${q_i}`}>
                        <span dangerouslySetInnerHTML={{ __html: qstn }} />
                      </p>
                    ))}
                    <h5>
                      {financialsVal?.[data.key][0] !== "none"
                        ? `$${formatValue(financialsVal?.[data.key][0])}`
                        : "-"}
                    </h5>
                  </React.Fragment>
                );
              })}
            </Card>
          </Col>
          <Col xs={24} md={8}>
            <Card title="Expenses">
              {financials.map((data, index) => {
                if ((!data.options && !data.type) || !data.key.includes("expenses"))
                  return null;

                return (
                  <React.Fragment key={index}>
                    {data.question.map((qstn, q_i) => (
                      <p key={`question-${q_i}`}>
                        <span dangerouslySetInnerHTML={{ __html: qstn }} />
                      </p>
                    ))}
                    <h5>
                      {financialsVal?.[data.key][0] !== "none"
                        ? `$${formatValue(financialsVal?.[data.key][0])}`
                        : "-"}
                    </h5>
                  </React.Fragment>
                );
              })}
            </Card>
          </Col>
          <Col xs={24} md={8}>
            <Card title="EBITDA">
              {financials.map((data, index) => {
                if ((!data.options && !data.type) || !data.key.includes("ebitda"))
                  return null;

                return (
                  <React.Fragment key={index}>
                    {data.question.map((qstn, q_i) => (
                      <p key={`question-${q_i}`}>
                        <span dangerouslySetInnerHTML={{ __html: qstn }} />
                      </p>
                    ))}
                    <h5>
                      {financialsVal?.[data.key][0] !== "none"
                        ? `$${formatValue(financialsVal?.[data.key][0])}`
                        : "-"}
                    </h5>
                  </React.Fragment>
                );
              })}
            </Card>
          </Col>
        </Row>
        <br />
        <Card style={{ paddingTop: 20 }}>
          {financials.map((data, index) => {
            if (
              (!data.options && !data.type) ||
              data.key.includes("ebitda") ||
              data.key.includes("expenses") ||
              data.key.includes("revenue")
            )
              return null;

            return (
              <React.Fragment key={index}>
                {data.question.map((qstn, q_i) => (
                  <p key={`question-${q_i}`}>
                    <span dangerouslySetInnerHTML={{ __html: qstn }} />
                  </p>
                ))}
                <h5>
                  {financialsVal?.[data.key][0] !== "none"
                    ? `$${formatValue(financialsVal?.[data.key][0])}`
                    : "-"}
                </h5>
              </React.Fragment>
            );
          })}
        </Card>
      </Modal>
      <DocumentsModal
        preview={documentModalPreview}
        previewHandler={documensModalHandler}
      />
      <NotesModal preview={notesModalPreview} previewHandler={notesModalHandler} />
    </React.Fragment>
  );
};

export default LeadsDashboard;
